const edu = {
 "about": {
  "whatH": "What it is",
  "whatB": "FluentLoop for Education gives a school's teachers and students GetFluentLoop's AI language practice, plus classes and assignments for teachers.",
  "pilotH": "The pilot",
  "pilotB": "Verified schools get a complimentary 90-day pilot. No credit card, and it never turns into a paid plan by itself.",
  "whoH": "Who it's for",
  "whoB": "Schools, universities, language schools and other educational institutions, applied for by a teacher or school administrator.",
  "getH": "What you get",
  "getB": "Classes with join links, missions and assignments, and teacher views of class progress.",
  "privacyH": "Privacy",
  "privacyB": "Teachers only see class work. Students' personal Fluent Friend chats, journals and private learning history stay private. We never store raw photos or voice.",
  "howH": "How it works",
  "howB": "Apply below. Our team reviews every application; submitting is a request, not automatic approval. You'll see the status here."
 },
 "publicSub": "A complimentary 90-day pilot for verified schools.",
 "signupCta": "Create an account to apply",
 "signinCta": "Sign in",
 "returnHint": "You'll come straight back here to apply after signing in.",
 "intro": "Give your students a full term to experience AI-powered language fluency practice — free for verified schools, with no credit card required.",
 "status": {
  "pending_review": "Under review",
  "needs_information": "More information requested",
  "approved": "Approved",
  "rejected": "Not approved"
 },
 "approvedLine": "Your school now has FluentLoop Education access. Enjoy!",
 "teacherLink": "Open Teacher dashboard →",
 "reviewerNote": "Reviewer note: {note}",
 "submittedOn": "Submitted {date}. Submitting an application is a request — not automatic approval.",
 "rejectedDefault": "Your school application was not approved at this time.",
 "resubmit": "You may submit a new application below.",
 "f": {
  "name": "Institution name *",
  "type": "Institution type",
  "country": "Country",
  "website": "Institution website",
  "email": "Your school / work email",
  "role": "Your role",
  "learners": "Approximate number of learners",
  "notes": "Brief note (optional)",
  "notesPh": "Tell us a little about your program.",
  "disclaimer": "No credit card required. We never collect student data. Submission is an application reviewed by our team — not automatic approval."
 },
 "types": {
  "school": "School (K-12)",
  "university": "University / College",
  "language_school": "Language school",
  "training_center": "Training center",
  "educational_nonprofit": "Educational nonprofit",
  "other_education": "Other education"
 },
 "roles": {
  "teacher": "Teacher",
  "school_admin": "School admin",
  "principal": "Principal",
  "director": "Director",
  "coordinator": "Coordinator",
  "other": "Other"
 },
 "toast": {
  "needName": "Please enter your institution name.",
  "alreadyOpen": "You already have an application in review.",
  "submitted": "Application submitted!",
  "failed": "Could not submit application."
 },
 "attest": "I confirm that I am applying in my professional role as an educator or authorized school representative.",
 "attestNeeded": "Please confirm the educator attestation.",
 "vTitle": "We need a little more information",
 "vIntro": "To verify your role at the school, please share:",
 "proofs": {
  "institutional_email": "Your institutional (school) email",
  "staff_page": "A link to an official staff page that lists you",
  "school_admin_confirmation": "Confirmation from your school's administrator",
  "other": "Other evidence of your school affiliation"
 },
 "vEmail": "Institutional email",
 "vEmailHint": "Used only as evidence. Your sign-in email does not change.",
 "vUrl": "Official staff-page link",
 "vNote": "Short note",
 "vSend": "Send information",
 "vReceived": "Thanks — we received your information. Your application is still under review.",
 "vSent": "Information sent.",
 "vFailed": "Could not send your information.",
 "ev": {
  "submitted": "Application submitted",
  "requested": "More information requested",
  "response": "Information received"
 },
 "approvedOnly": "Approved {date}",
 "approvedActive": "Approved {date} · School pilot active until {end}",
 "approvedEnded": "Approved {date} · School pilot ended {end}",
 "teach": {
  "welcome": "Welcome to FluentLoop for Education",
  "pilotActive": "Education pilot active · Ends {date}",
  "pilotEnded": "Education pilot ended {date}",
  "pilotInactive": "Education pilot not active",
  "next": "Start by creating a class for the language you teach. You'll get a join code and link to share with your students.",
  "createFirst": "Create your first class",
  "howLink": "How FluentLoop for Education works",
  "s1H": "Create a class", "s1B": "Choose the language and level.",
  "s2H": "Invite students", "s2B": "Share the class join code or link. Students join with their own account.",
  "s3H": "Assign and teach", "s3B": "Create Fluency Missions and assign them to your class.",
  "s4H": "Follow class progress", "s4B": "See assignment completion and class activity.",
  "canSeeH": "What teachers can see",
  "canSee": "Class membership|Assigned-work completion|School and class activity|Results of your lessons and assignments",
  "cantSeeH": "What teachers cannot see",
  "cantSee": "Private Fluent Friend conversations|Journal|Private learning evidence|Personal Interview Practice|Unrelated personal learning",
  "learnMore": "Learn more about FluentLoop for Education",
  "missionLibrary": "Mission Library",
  "createBtn": "Create class",
  "cancel": "Cancel",
  "newClass": "New class",
  "name": "Class name",
  "namePh": "e.g. Spanish A1 — Group 2",
  "lang": "Language being learned",
  "level": "Level (CEFR)",
  "desc": "Description (optional)",
  "needOrg": "You need a school to create a class.",
  "needName": "Please enter a class name.",
  "created": "Class created",
  "failed": "Something went wrong. Please try again.",
  "activeClasses": "Active classes",
  "activeStudents": "Active students",
  "schools": "Schools",
  "noClasses": "No active classes yet.",
  "students": {"one": "{count} student", "other": "{count} students"},
  "code": "Code",
  "archived": "Archived",
  "notTeacher": "You're not a teacher at a school yet.",
  "apply": "Apply via FluentLoop for Education",
  "requestContinuation": "Request continuation",
  "continuationPending": "Continuation requested",
  "continuationSent": "Continuation requested. Our team will review it."
 },
 "cls": {
  "expiredH": "Education pilot expired",
  "expiredB": "Existing classes and assigned work remain available, but new school work cannot be created until Education access is renewed.",
  "studentExpired": "This school's Education access has ended, so new students can't join right now. Your personal FluentLoop account is not affected.",
  "archive": "Archive", "restore": "Restore",
  "invite": "Invite students", "classCode": "Class code",
  "copyCode": "Copy code", "newCode": "New code", "copyLink": "Copy invite link", "newLink": "New link",
  "showQr": "Show QR code", "hideQr": "Hide QR code", "qrAlt": "QR code for the class invite link",
  "qrNote": "Students can scan this to open the class invite link. It's created on this device.",
  "codeCopied": "Code copied", "linkCopied": "Invite link copied", "regenerated": "New one created",
  "removed": "Student removed from the class", "remove": "Remove from class",
  "progressFailed": "Could not load progress.", "resultsFailed": "Could not load results.",
  "noAccess": "You don't have access to this class.",
  "roster": "Roster ({n})", "noStudents": "No students yet. Share the code or link above.", "joined": "Joined {date}",
  "progress": "Progress",
  "privacyNote": "Class work only. Personal learning (Friend, Journal, private vocabulary) is never shown.",
  "aCompleted": "Assignments completed", "inProgress": "In progress", "notStarted": "Not started", "completed": "Completed",
  "lastActivity": "Last class activity", "late": "(late)",
  "assignments": "Assignments", "createMission": "Create Mission",
  "noAssignments": "No missions assigned yet. Create a Fluency Mission to get your class practising.",
  "minutes": "~{n} min", "due": {"overdue": "overdue", "due_today": "due today", "due_soon": "due soon"},
  "completedLower": "completed",
  "insights": "Class Insights", "completionRate": "Completion rate", "participation": "Participation",
  "assignedWords": "Assigned words the class is still mastering", "needPractice": "Missions that may need more practice",
  "pctDone": "{n}% done", "close": "Close", "noStudentsInClass": "No students in this class yet.",
  "joinTitle": "Join a class", "joinAuth": "Log in or create your free FluentLoop account to join this class.",
  "continue": "Continue", "joinInvalid": "This invitation is invalid or no longer active.",
  "joinBtn": "Join this class", "joining": "Joining…", "joinedToast": "You've joined the class!", "joinFailed": "Could not join."
 },
 "stu": {
  "intro": "Your school classes. Your personal FluentLoop learning stays separate and private.",
  "none": "You're not in any class yet.",
  "unfinished": "{n} to do", "completedN": "{n} completed", "pilotEndedTag": "Pilot ended",
  "pilotEnded": "Your school's FluentLoop Education pilot has ended. Your personal FluentLoop account is unchanged.",
  "haveCode": "Have a class code?", "joinWithCode": "Have a class code? Join a class",
  "continue": "Continue", "start": "Start", "teacher": "Teacher",
  "assignments": "Assignments", "noAssignments": "No assignments yet.",
  "status": {"not_started": "Not started", "in_progress": "In progress", "completed": "Completed"},
  "due": "Due {date}", "classVocab": "Class vocabulary",
  "privacy": "Your teacher sees only your work in this class. Your personal FluentLoop learning stays private.",
  "pendingCount": {"one": "{count} school assignment pending", "other": "{count} school assignments pending"},
  "signIn": "Sign in to join", "signUp": "Create a free account",
  "codeInvalid": "That class code isn't valid. Please check it with your teacher.",
  "tooMany": "Too many attempts. Please wait a minute and try again.", "tryAgain": "Try another code"
 },
 "faq": {
  "title": "Education Q&A",
  "g": {"schools": "For schools and teachers", "privacy": "Privacy & data", "students": "For students", "pilot": "Pilot & expiry"},
  "what": {"q": "What is FluentLoop for Education?", "a": "A way for schools to use FluentLoop with their classes. Teachers create classes, assign Fluency Missions and follow class progress, while each student keeps their own private FluentLoop account."},
  "pilot90": {"q": "How does the 90-day school pilot work?", "a": "After approval, your school gets 90 days of FluentLoop Education at no cost. Teachers and enrolled students get Education access for the length of the pilot."},
  "whoApply": {"q": "Who can apply?", "a": "Teachers and authorised school staff at schools, universities, language schools and other educational organisations."},
  "verified": {"q": "How are teachers verified?", "a": "Every application is reviewed by our team. We may ask for an institutional email address or a link to an official school staff page before approving. Nobody is approved automatically."},
  "createClass": {"q": "How do I create a class?", "a": "Open the Teacher dashboard, choose Create class, then enter the class name, the language and the level."},
  "studentsJoin": {"q": "How do students join?", "a": "Share the class's 6-character code, its invite link or its QR code. Students sign in with their own FluentLoop account and confirm the class."},
  "roles": {"q": "What is the difference between Teacher and School admin?", "a": "Teachers run their own classes. School admins can also manage every class in the school and request a pilot continuation."},
  "continuation": {"q": "How do I request a pilot continuation?", "a": "A School admin can choose Request continuation on the Teacher dashboard as the pilot nears its end. Our team reviews every request."},
  "teacherSee": {"q": "What can teachers see about students?", "a": "Class membership, progress on work assigned in the class, class activity, and results of their own lessons and assignments."},
  "teacherCant": {"q": "What can't teachers see?", "a": "Anything from a student's personal FluentLoop learning: Fluent Friend conversations, Journal, private learning evidence, personal vocabulary, personal Interview Practice and unrelated practice history."},
  "friendJournal": {"q": "Can teachers see Fluent Friend conversations or Journals?", "a": "No. Fluent Friend conversations and Journal entries are always private to the student."},
  "personalVocab": {"q": "Can my teacher see my personal vocabulary?", "a": "No. Teachers only see progress on vocabulary that was assigned in their class."},
  "joinWhat": {"q": "What happens when I join a FluentLoop class?", "a": "The class is added to My classes, and your teacher's assignments appear there and on your Dashboard. Nothing in your personal account is shared."},
  "personalAccount": {"q": "Can I still use my personal FluentLoop account?", "a": "Yes. Everything in your account stays available, under your normal account and plan."},
  "findClass": {"q": "Where do I find my class?", "a": "Open More → My classes. Each class shows your school, teacher and assignments."},
  "findAssignments": {"q": "Where do I find assignments?", "a": "Inside each class in My classes. Unfinished school work also appears as a small card on your Dashboard."},
  "inviteLink": {"q": "What happens when I click a class invite link?", "a": "You see the class and school and confirm that you want to join. If you aren't signed in yet, you sign in or sign up first and then come straight back to the class."},
  "multiClass": {"q": "Can I belong to more than one class?", "a": "Yes. All your classes appear in My classes."},
  "leaveData": {"q": "Does leaving or finishing a school class delete my personal FluentLoop data?", "a": "No. Your personal FluentLoop data stays in your account."},
  "pilotEnds": {"q": "What happens when the pilot expires?", "a": "No new school work can be created: no new classes, assignments or missions, and no new students can join. Nothing is deleted, and access resumes if the pilot is renewed."},
  "finishAfter": {"q": "Can students finish existing assignments after expiry?", "a": "Yes. Students already in a class can finish assignments that were set before the pilot ended."},
  "dataAfter": {"q": "What happens to classes and results after expiry?", "a": "They stay available to view. Classes, rosters, assignments and results are not deleted."},
  "studentPilotEnds": {"q": "What happens when my school's pilot ends?", "a": "You can still finish work your teacher had already assigned. Your personal FluentLoop account is unchanged."}
 }
};
export default edu;
